import { AsyncActionHandler } from 'action-handler';
import { setCurrentlySyncing } from 'actions/gallery';

export default new AsyncActionHandler({
  name: 'trigger_app_sync',
  stateProp: 'triggerAppSync',
  handler: ({ requiresWifi = false, force = false } = {}) => async (
    dispatch,
    getState
  ) => {
    const { currentlySyncing } = getState().gallery;

    if (force || !currentlySyncing) {
      await window.__webview_comms__.trigger('app-sync', { requiresWifi });
      await dispatch(setCurrentlySyncing({ wifi: requiresWifi }));
    }
  }
});
